// Mirrors /app/backend/mysa.py column contract: the 16 vendor fields + queue meta.
import { VENDOR_FIELDS } from "@/lib/fields";

export const VENDOR_COLUMN_KEYS = VENDOR_FIELDS.map((f) => f.key);

export const VENDOR_LABELS = VENDOR_FIELDS.reduce((acc, f) => {
  acc[f.key] = f.csv || f.label;
  return acc;
}, {});

export const EXTRA_COLUMNS = [
  { key: "amount", label: "Amount", group: "Payment" },
  { key: "currency", label: "Currency", group: "Payment" },
  { key: "approver_email", label: "Approver", group: "Payment" },
  { key: "status", label: "Status", group: "Meta" },
  { key: "source_subject", label: "Source Mail Subject", group: "Source" },
  { key: "source_from", label: "Source Mail From", group: "Source" },
  { key: "source_date", label: "Source Mail Date", group: "Source" },
  { key: "source_link", label: "Gmail Link", group: "Source" },
  { key: "category", label: "Mail Category", group: "Meta" },
  { key: "extracted_at", label: "Extracted At", group: "Meta" },
];

export const EXTRA_COLUMN_KEYS = EXTRA_COLUMNS.map((c) => c.key);

export const COLUMN_LABELS = {
  ...VENDOR_LABELS,
  ...EXTRA_COLUMNS.reduce((acc, c) => {
    acc[c.key] = c.label;
    return acc;
  }, {}),
};

export const ALL_COLUMN_KEYS = [...VENDOR_COLUMN_KEYS, ...EXTRA_COLUMN_KEYS];

export const COLUMN_GROUPS = [
  ...VENDOR_FIELDS.reduce((acc, f) => {
    if (!acc.includes(f.group)) acc.push(f.group);
    return acc;
  }, []),
  "Payment",
  "Source",
  "Meta",
];

export const COLUMN_GROUP_OF = {
  ...VENDOR_FIELDS.reduce((acc, f) => {
    acc[f.key] = f.group;
    return acc;
  }, {}),
  ...EXTRA_COLUMNS.reduce((acc, c) => {
    acc[c.key] = c.group;
    return acc;
  }, {}),
};

export const MONO_COLUMN_KEYS = [
  ...VENDOR_FIELDS.filter((f) => f.mono).map((f) => f.key),
  "amount",
];

export const colLabel = (key) => COLUMN_LABELS[key] || key;

export const groupedColumns = () =>
  COLUMN_GROUPS.map((group) => ({
    group,
    keys: ALL_COLUMN_KEYS.filter((k) => COLUMN_GROUP_OF[k] === group),
  })).filter((g) => g.keys.length > 0);
